<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t(titleKey)"></page-title>
            </div>

            <div class="card-header" v-if="showSettingsBtn">
                <i class="fas fa-cogs pointer fa-2x float-right text-success"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    v-if="showUserSettingsForm"
                                    @change="gridSettingsChanged">
                </grid-user-settings>
                <div style="clear: both;"></div>
                <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                    <div class="form-inline col-lg-6 col-md-12">

                    </div>
                    <div class="input-group col-lg-6 col-md-12">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

            </div>

            <div class="card-body">
                <!-- Datasource на родителските номенклатури -->
                <!-- requestEnd="datasorceRequestEnd" се извиква след края на всяка заявка на сорса -->
                <!-- error="dataSourceError" се извиква след грешка на заявка на сорса -->
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <!-- Грид на родителските номенклатури -->
                <!-- v-on:detailinit="detailInit" ще вмъкне грид в дадения ред  -->
                <!-- v-on:databound="dataBound"" се грижи за горното  -->
                <kendo-grid ref="parentGrid"
                            id="parentGrid"
                            data-source-ref="datasource1"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            v-on:detailinit="detailInit"
                            :data-bound="dataBound"
                            :toolbar="parentGridToolbar">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('registers.nomenclatures.gridHeaders.id')"
                                       v-html="rawHtml"
                                       :expandable="true"
                                       :lockable="true"
                                       :locked="false"
                                       :width="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'parentModel'"
                                       :title="$t('registers.nomenclatures.gridHeaders.parentName')"
                                       :editor="parentIdDropDownEditor"
                                       :template="parentCellTemplate"
                                       :hidden="true"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('registers.nomenclatures.gridHeaders.name')"
                                       :width="350"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.nomenclatures.gridHeaders.nameEn')"
                                       :width="350"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'sort'"
                                       :title="$t('registers.nomenclatures.gridHeaders.sort')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'description'"
                                       :title="$t('registers.nomenclatures.gridHeaders.description')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deactivated'"
                                       :title="$t('registers.nomenclatures.gridHeaders.deactivated')"
                                       :width="120"
                                       :hidden="true"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :template="activeCellTemplate"
                                       :title="$t('registers.nomenclatures.gridHeaders.active')"
                                       :width="120"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :title="$t('actions')"
                                       field="btnsColumn"
                                       :sortable="false"
                                       :filterable="false"
                                       :template="parentBtnsTemplate"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :command="parentGridCommands"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>

        <MassEditModal :show.sync="showMassEdit"
                       :grid="selectedRowsGrid"
                       @onSave="onSelectedRowsEdit"
                       v-model="selectedRowsIds">
        </MassEditModal>

        <JsonFormatter v-model="dataReferences" :show.sync="showDataReferences"
                       :titleKey="'buttons.links.tooltipText'"
                       @onClose="onDataReferencesClose">
        </JsonFormatter>

        <ReplacementHistoryModal
            v-model="replacementHistoryModel"
            :show.sync="showReplacementHistory"
            @onClose="onReplacementHistoryClose" />
    </div>
</template>


<script>
    import Vue from 'vue';
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import GridUserSettings from "@/components/grid/UserSettings";
    import PageTitle from '@/components/common/PageTitle';
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import nomenclaturesService from '@/services/nomenclature.service';
    import dataReferencesService from '@/services/dataReferences.service';
    import MassEditModal from '@/components/administration/nomenclature/massEdit.modal';
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";
    import ReplacementHistoryModal from "@/components/administration/dataReferences/replacement.history.modal";

    import { mapGetters } from 'vuex';

    export default {
        components: {
            'grid-user-settings': GridUserSettings,
            PageTitle,
            MassEditModal,
            JsonFormatter,
            ReplacementHistoryModal
        },
        props: {
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "nomenclatureEditor", // Трабва на конпонентата за бутоните за дашборд настройките
                titleKey: 'nomenclatureEditor', // Трабва на конпонентата за бутоните за дашборд настройките
                rawHtml: "",
                detailsGridContextMenuFilter: ".k-detail-row tbody tr[role='row']",
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.id', },
                    name: { name: 'name', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.name', validation: { required: true } },
                    nameEn: { name: 'nameEn', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.nameEn' },
                    parentModel: { name: 'parent', editable: true, defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' }, visible: false, titleKey: 'registers.nomenclatures.gridHeaders.parentName' },
                    description: { name: 'description', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.description' },
                    sort: { name: 'sort', type: 'number', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.sort', validation: { required: true, min: 1 } },
                    active: { name: 'active', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.active', defaultValue: true },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: true, nullable: false, visible: false, titleKey: 'registers.nomenclatures.gridHeaders.deactivated', validation: { required: false }, defaultValue: false },
                    hexColor: { name: 'hexColor', type: 'string', editable: true, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/nomenclatures/listParents',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/nomenclatures/create',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/nomenclatures/update',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                working: false,
                showUserSettingsForm: false,
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup',
                        window: {
                            title: "Номенклатура",
                            animation: true,
                            activate: this.editWindowActivate
                        }
                    }
                },
                showMassEdit: false,
                selectedRowsIds: null,
                selectedRowsGrid: null,
                dataReferences: '',
                showDataReferences: false,
                showReplacementHistory: false,
                replacementHistoryModel: null,
            };
        },
        methods: {
            dataBound(ev) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadColumnsVisibilitySettings();
                }

                ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            detailInit: function (e) {
                $('<div />').appendTo(e.detailCell).kendoGrid({
                    dataSource: {
                        transport: {
                            read: {
                                url: this.$store.getters.baseUrl + '/api/nomenclatures/listChildren',
                                dataType: 'json',
                                type: 'POST',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            create: {
                                url: this.$store.getters.baseUrl + '/api/nomenclatures/create',
                                dataType: 'json',
                                type: 'POST',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            update: {
                                url: this.$store.getters.baseUrl + '/api/nomenclatures/update',
                                dataType: 'json',
                                type: 'PUT',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            parameterMap: this.parameterMap
                        },
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true,
                        filter: { // това филтрира само елементите за дадена родителска категория
                            field: 'parentId',
                            operator: 'eq',
                            value: e.data.id
                        },
                        schema: {
                            model: {
                                id: 'id',
                                fields: {
                                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.id' },
                                    parentId: { name: 'parentId', type: 'number', editable: false, visible: false },
                                    name: { name: 'name', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.name', validation: { required: true } },
                                    nameEn: { name: 'nameEn', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.nameEn' },
                                    parentModel: { defaultValue: { id: e.data.id, text: e.data.name, textEn: e.data.nameEn }, showHideColumn: false },
                                    description: { name: 'description', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.description' },
                                    sort: { name: 'sort', type: 'number', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.sort', validation: { required: true, min: 1 } },
                                    active: { name: 'active', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.active', defaultValue: true },
                                    deactivated: { name: 'deactivated', type: 'boolean', editable: true, nullable: false, visible: false, titleKey: 'registers.nomenclatures.gridHeaders.deactivated', validation: { required: false }, defaultValue: false },
                                    hexColor: { name: 'hexColor', type: 'string', editable: true, nullable: true, visible: true },
                                }
                            },
                            total: 'total',
                            data: 'data'
                        },
                        error: this.dataSourceError,
                        requestEnd: this.datasorceRequestEnd,
                    },
                    editable: this.gridOptions.editable,
                    pageable: this.gridOptions.pageable,
                    filterable: this.gridOptions.filterable,
                    reorderable: this.gridOptions.reorderable,
                    resizable: this.gridOptions.resizable,
                    scrollable: this.gridOptions.scrollable,
                    sortable: this.gridOptions.sortable,
                    columnMenu: this.gridOptions.columnMenu,
                    persistSelection: true,
                    toolbar: this.childGridToolbar,
                    columns: [
                        {
                            selectable: true,
                            width: 60,
                            lockable: true,
                            locked: true,
                        },
                        {
                            field: 'id',
                            title: this.$t('registers.nomenclatures.gridHeaders.id'),
                            width: 100,
                            lockable: true,
                            locked: true
                        },
                        {
                            field: 'parentId',
                            title: this.$t('registers.nomenclatures.gridHeaders.parentId'),
                            hidden: true,
                            width: 100,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'parentModel',
                            editor: this.parentIdDropDownEditor,
                            title: this.$t('registers.nomenclatures.gridHeaders.parentName'),
                            template: this.parentCellTemplate,
                            width: 300,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'name',
                            title: this.$t('registers.nomenclatures.gridHeaders.name'),
                            width: 300,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'nameEn',
                            title: this.$t('registers.nomenclatures.gridHeaders.nameEn'),
                            width: 300,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'description',
                            title: this.$t('registers.nomenclatures.gridHeaders.description'),
                            width: 150,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'sort',
                            title: this.$t('registers.nomenclatures.gridHeaders.sort'),
                            width: 200,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'deactivated',
                            title: this.$t('registers.nomenclatures.gridHeaders.deactivated'),
                            hidden: true,
                            width: 150,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'active',
                            title: this.$t('registers.nomenclatures.gridHeaders.active'),
                            template: this.activeCellTemplate,
                            width: 150,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'hexColor',
                            editor: this.colorEditor,
                            template: this.colorEditorTemplate,
                            title: this.$t('registers.nomenclatures.gridHeaders.color'),
                            width: 130,
                            lockable: true,
                            locked: false
                        },
                        {
                            width: 200,
                            lockable: true,
                            locked: false,
                            command: this.childGridCommmands
                        }],
                    excelExport: this.beforeExcelExport,
                })
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            parentCellTemplate: function (dataItem) {
                if (dataItem.parentModel === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.parentModel.textEn : dataItem.parentModel.text) + '</span>';

                return templateHtml;
            },
            parentIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectNomenclature'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/Dropdown/GetParentNomenclatures',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            },
                            requestEnd: this.dropDownEditorDatasorceRequestEnd(options)
                        }
                    });
            },
            colorEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoColorPicker({
                        palette: '', // "basic" -- displays 20 basic colors, "websafe" -- display the "web-safe" color palette, If palette is missing or null, the widget will display the HSV selector.
                        clearButton: true,
                        preview: true
                    });
            },
            colorEditorTemplate: function (dataItem) {
                if (!dataItem.hexColor) {
                    return kendo.htmlEncode("");
                }
                let templateHtml = '<span class="badge badge-pill" style="background-color:' + dataItem.hexColor + ';color:white;">' + kendo.htmlEncode(dataItem.hexColor) + '</span>';

                return templateHtml;
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    // this.$vs.notify({
                    //    title: '',
                    //    text: this.$t('personalSettingsLoaded'),
                    //    color: 'success',
                    //    time: this.$store.getters.notificationDuration,
                    // })

                    if (response.data.settings === null) {
                        // Липсват запазени каквито и да е потребителски настройки. Осват тези по подразбиране
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }

                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)
                            && this.schemaModelFields[key].hasOwnProperty('visible')) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.parentGrid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (!column.field
                        || !this.schemaModelFields.hasOwnProperty(column.field)
                        || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                        continue;
                    }

                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    } else {
                        grid.hideColumn(column);
                    }
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "update" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            dropDownEditorDatasorceRequestEnd(options) {},
            editWindowActivate(e) {},
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.parentGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.parentGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            refreshParentGrid() {
                const grid = this.$refs.parentGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            deactivateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (!args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                nomenclaturesService
                    .deactivate(args.id)
                    .then(response => {
                        this.working = false;
                        this.refreshParentGrid();

                        this.$vs.notify({
                            title: this.$t('buttons.deactivate.action'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.working = false;

                        this.$vs.notify({
                            title: this.$t('buttons.deactivate.action'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            activateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                nomenclaturesService
                    .activate(args.id)
                    .then(response => {
                        this.working = false;
                        this.refreshParentGrid();

                        this.$vs.notify({
                            title: this.$t('buttons.activate.action'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.working = false;

                        this.$vs.notify({
                            title: this.$t('buttons.activate.action'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            dataReferencesCommandClick(e) {
                e.preventDefault();
                if (!this.claims.dataReferences.read) {
                    return this.$router.push(`/unauthorized`);
                }
                const tr = $(e.currentTarget).closest("tr");
                const childGrid = tr.closest('.k-grid').data("kendoGrid");
                const dataItem = childGrid.dataItem(tr);

                if (!dataItem) {
                    return;
                }

                return this.getDataReferences(dataItem.id);
            },
            dataReferencesClick(dataItem) {
                if (!this.claims.dataReferences.read) {
                    return this.$router.push(`/unauthorized`);
                }

                if (!dataItem) {
                    return;
                }

                return this.getDataReferences(dataItem.id);
            },
            getDataReferences(id) {
                dataReferencesService
                    .checkReferences('N', 'Nomenclature', id, this.dataReferencesListCount, true)
                    .then(response => {
                        if (response.data) {
                            this.dataReferences = response.data;
                        }

                        this.showDataReferences = true;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            onDataReferencesClose() {
                this.dataReferences = '';
                this.showDataReferences = false
            },
            dataReferencesReplaceCommandClick(e) {
                e.preventDefault();
                if (!this.claims.dataReferences.update) {
                    return this.$router.push(`/unauthorized`);
                }

                const tr = $(e.currentTarget).closest("tr");
                const childGrid = tr.closest('.k-grid').data("kendoGrid");
                const dataItem = childGrid.dataItem(tr);

                if (!dataItem) {
                    return;
                }

                kendo.prompt(`${this.$t('dataReference.replacePrompt')}`, '')
                    .then(function (data) {
                        const replacementId = Number(data);
                        if (isNaN(replacementId)) {
                            this.$vs.notify({
                                    title: this.$t('notifications.error'),
                                    text: 'replacementId is not a number',
                                    color: 'danger',
                                    time: this.$store.getters.notificationDuration
                                });
                            return;
                        }

                        const model = {
                            schemaName: 'N',
                            tableName: 'Nomenclature',
                            replacedId: dataItem.id,
                            replacementId: replacementId
                        }
                        dataReferencesService.replaceReferences(model)
                            .then(response => {
                                this.$vs.notify({
                                    title: this.$t('buttons.replace.btnText'),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration
                                });
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t('buttons.replace.btnText'),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters.notificationDuration
                                });
                            });
                    }.bind(this));
            },
            replacementHistoryCommandClick(e) {
                e.preventDefault();
                if (!this.claims.dataReferences.read) {
                    return this.$router.push(`/unauthorized`);
                }

                const tr = $(e.currentTarget).closest("tr");
                const childGrid = tr.closest('.k-grid').data("kendoGrid");
                const dataItem = childGrid.dataItem(tr);

                if (!dataItem) {
                    return;
                }

                this.replacementHistoryModel = {
                    schemaName: 'N',
                    tableName: 'Nomenclature',
                    entityId: dataItem.id
                };
                this.showReplacementHistory = true;
            },
            onReplacementHistoryClose() {
                this.replacementHistoryModel = null;
                this.showReplacementHistory = false
            },
            parentBtnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.parentGrid,
                        btns:
                            [
                                {
                                    name: "deactivation",
                                    text: "",
                                    tooltip: this.$t('buttons.deactivate.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-lock",
                                    show: this.hasDeleteRights && e.active,
                                    clickHandler: this.deactivateBtnClick
                                }, {
                                    name: 'activation',
                                    text: "",
                                    tooltip: this.$t('buttons.activate.btnText'),
                                    class: 'btn btn-success',
                                    icon: "fas fa-lock-open",
                                    show: this.hasDeleteRights && !e.active,
                                    clickHandler: this.activateBtnClick
                                },
                                {
                                    name: 'dataReferences',
                                    text: "",
                                    tooltip: this.$t('buttons.links.tooltipText'),
                                    class: 'btn btn-info',
                                    icon: "fas fa-link",
                                    show: this.$store.getters.claims.dataReferences.read,
                                    clickHandler: this.dataReferencesClick
                                }
                            ]

                    }
                };
            },
            beforeExcelExport(e) {
                e.preventDefault();

                this.massEditSelected(e);
            },
            massEditSelected(e) {
                const selectedIds = this.$helpers.getGridSelectedRowsIds(e.sender);
                if (!selectedIds || selectedIds.length <= 0) {
                    this.$vs.notify({
                        title: this.$t('buttons.edit.btnText'),
                        text: this.$t('registers.nomenclatures.warnings.emptySelection'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                    return;
                }

                this.selectedRowsIds = selectedIds;
                this.selectedRowsGrid = e.sender;
                this.showMassEdit = true;
            },
            onSelectedRowsEdit(grid) {
                if (grid) {
                    grid.dataSource.read();
                }

                this.selectedRowsGrid = null;
            }
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['isEnVersion', 'claims', 'dataReferencesListCount']),
            token: function () {
                return this.$store.getters.authToken;
            },
            parentGridToolbar() {
                const toolbarItems = [];
                if (this.hasCreateRights) {
                    toolbarItems.push({ name: 'create', text: this.$t('buttons.create.btnText') });
                }

                return toolbarItems;
            },
            parentGridCommands: function () {
                const commands = []
                if (this.hasUpdateRights) {
                    commands.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }

                return commands;
            },
            childGridToolbar() {
                const toolbarItems = [];
                if (this.hasCreateRights) {
                    toolbarItems.push({ name: 'create', text: this.$t('buttons.create.btnText') });
                }

                if (this.hasReadRights) {
                    toolbarItems.push({ name: 'excel', text: this.$t('buttons.editSelected.btnText'), iconClass: 'k-icon k-i-pencil' });
                }

                return toolbarItems;
            },
            childGridCommmands() {
                const commands = [];

                if (this.hasUpdateRights) {
                    commands.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }

                if (this.$store.getters.claims.dataReferences.read) {
                    commands.push({
                        name: 'checkLinks',
                        text: this.$t('buttons.links.btnText'),
                        click: this.dataReferencesCommandClick,
                    });
                }

                if (this.$store.getters.claims.dataReferences.update) {
                    commands.push({
                        name: 'referencesReplace',
                        text: this.$t('buttons.replace.btnText'),
                        click: this.dataReferencesReplaceCommandClick,
                    });
                }

                if (this.$store.getters.claims.dataReferences.read) {
                    commands.push({
                        name: 'replacementHistory',
                        text: this.$t('buttons.history.btnText'),
                        click: this.replacementHistoryCommandClick,
                    });
                }

                return commands;
            },
            hasReadRights() {
                return this.claims.nomenclature.read;
            },
            hasCreateRights() {
                return this.claims.nomenclature.create;
            },
            hasUpdateRights() {
                return this.claims.nomenclature.update;
            },
            hasDeleteRights() {
                return this.claims.nomenclature.delete;
            }
        }
    }
</script>

<style scoped>
</style>
